import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from '@app/app.config';
import { LoadingProvider } from '@app/components/_shared/loading-spinner/loading-spinner.component';
import { LoginRequestModel } from '@app/models/auth/loginRequest.model';
import { LoginResponseModel } from '@app/models/auth/loginResponse.model';
import { AuthService } from '@app/services/auth.service';
import { LocalisationService } from '@app/services/localisation.service';
import { Globals } from 'globals';
import { ToastrService } from 'ngx-toastr';
import { PrivacyPolicyUpdateComponent } from '@app/components/legal/privacy-policy-update/privacy-policy-update.component';
import { CourseAreaListComponent } from '@app/components/course-areas/list/course-area-list/course-area-list.component';
import { WelcomeComponent } from '@app/components/welcome/welcome.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  static route: string = 'login';

  locale: any = {};

  username: string = null;

  paymentPortal: string = AppConfig.paymentPortal;

  showPassword: boolean = false;
  passwordType: string = 'password';
  passwordToggleText: string = 'Show';

  canRegister: boolean = AppConfig.canRegister;

  loginForm: FormGroup;
  showForm: boolean = false;

  public formSubmitted: boolean = false;

  private returnUrl: string;

  constructor(
    private globals: Globals,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private spinner: LoadingProvider,
    private localistaion: LocalisationService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    var urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('token')) {
      this.spinner.show(this.locale.findingYourAccount);
      this.authService
        .loginWithToken(urlParams.get('token'))
        .finally(() => {
          this.spinner.hide();
          this.showForm = true;
        })
        .subscribe(
          succeeded => {
            document.cookie = 'state=1';

            if (sessionStorage.getItem('areas-seen') == 'true') {
              this.router.navigate([`/centigrade/${CourseAreaListComponent.route}`]);
            } else {
              this.router.navigate([`/${WelcomeComponent.route}`]);
            }
          },
          err => {
            this.loginFailed(err);
          }
        );
    } else {
      this.showForm = true;
    }

    let locale = this.localistaion.getTranslationsForComponent('LoginComponent');

    this.locale = locale;

    var validationModel = {};

    Object.getOwnPropertyNames(new LoginRequestModel()).forEach(key => {
      validationModel[key] = [null, Validators.required];
    });

    // Display logout message
    if (this.authService.getSignedOut() == true) {
      this.toastr.success(this.locale.signedOutMessage);
      this.authService.setSignedOut(false);
    }

    // get return url from the route parameters
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';

    this.loginForm = this.formBuilder.group(validationModel);

    if (urlParams.has('e')) {
      this.username = urlParams.get('e');
      this.loginForm.setValue({ username: this.username, password: '' });
    }
  }

  setFormSubmitted(value) {
    this.formSubmitted = value;
  }

  // Clear messages when input fields are active
  onClickInput() {}

  togglePassword() {
    this.showPassword = !this.showPassword;
    this.passwordType = this.showPassword ? 'text' : 'password';
  }

  login(model: LoginRequestModel) {
    if (!this.loginForm.valid) {
      var res = new LoginResponseModel();
      res.returnCode.label = 'E_INPUT_INVALID';
      this.loginFailed(res);
      return;
    } else {
      this.spinner.show(this.locale.findingYourAccount);
      this.setFormSubmitted(true);
      this.authService
        .login(model)
        .finally(() => {
          this.spinner.hide();
          this.setFormSubmitted(false);
        })
        .subscribe(
          succeeded => {
            this.spinner.hide();
            document.cookie = 'state=1';

            if (succeeded.hasSeenLatestPolicy) {
              if (this.returnUrl != '') {
                this.router.navigate([this.returnUrl]);
              } else {
                // this.router.navigate([`/${PrivacyPolicyUpdateComponent.route}`]);
                if (sessionStorage.getItem('areas-seen') == 'true') {
                  this.router.navigate([`/centigrade/${CourseAreaListComponent.route}`]);
                } else {
                  this.router.navigate([`/${WelcomeComponent.route}`]);
                }
              }
            } else {
              if (this.returnUrl != '') {
                this.router.navigate([`/${PrivacyPolicyUpdateComponent.route}`], {
                  queryParams: { returnUrl: this.returnUrl }
                });
              } else {
                this.router.navigate([`/${PrivacyPolicyUpdateComponent.route}`]);
              }
            }
          },
          err => {
            this.loginFailed(err);
          }
        );
    }
  }

  loginFailed(err: LoginResponseModel) {
    let text = this.locale.loginFailedDefaultModalMessage;

    switch (err.returnCode.label) {
      case 'E_USER_NOT_ACTIVE':
        text = this.locale.loginFailedInactiveUserModalMessage;
        break;

      case 'E_TOO_MANY_ATTEMPTS':
        text = err.returnCode.message;
        break;
    }

    this.toastr.error(text, this.locale.loginFailedDefaultModalTitle);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/account/login/login.component.ts